/**
 * Returns an SVG that is just a light gray background that fills the screen
 * @returns base64 encoded data URI format SVG image of viewport filling light background
 */
export const getGrayBackgroundSVG = () => {
  return 'data:image/svg+xml;base64,PHN2ZyB4bWx    ucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHByZXNlcnZlQX    NwZWN0UmF0aW89InhNaW5ZTWluIG1lZXQiIHZpZXdCb3g9IjAgMCAzN    TAgMzUwIj48c3R5bGU+LmJhc2UgeyBmaWxsOiB3aGl0ZTsgZm9udC1m    YW1pbHk6IHNlcmlmOyBmb250LXNpemU6IDE0cHg7IH08L3N0eWxlPjx    yZWN0IHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIGZpbGw9IiNlMG    UwZTc4MCIgLz48L3N2Zz4=';
};
